/* eslint-disable react/prop-types,react/forbid-prop-types,react/require-default-props */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import MainNavigation from '../MainNavigation';
import DesktopNavContainer from './DesktopNavContainer';
import DesktopNavigationBar from './DesktopNavigationBar';
import MenuButtons from '../MenuButtons';
import DesktopNavTitle from './DesktopNavTitle';

@inject('productsStore')
@observer
class DesktopNavigation extends Component {
  render() {
    const { windowStore, parsedStructure, productsStore } = this.props;
    return (
      <React.Fragment>
        <MainNavigation />
        {
          Array.isArray(parsedStructure) && parsedStructure.length !== 0
            ? (
              <DesktopNavContainer scrollDirection={windowStore.scrollDirection}>
                <DesktopNavigationBar scrollRefId="nav-parent">

                  {productsStore.currentProduct.name ? (
                    <DesktopNavTitle>
                      { `${productsStore.currentProduct.name}:` }
                    </DesktopNavTitle>
                  ) : ''}

                  <MenuButtons parsedStructure={parsedStructure} />
                </DesktopNavigationBar>
              </DesktopNavContainer>
            )
            : null
        }
      </React.Fragment>
    );
  }
}
DesktopNavigation.propTypes = {
  windowStore: PropTypes.object,
  parsedStructure: PropTypes.array,
};
DesktopNavigation.defaultProps = {
  parsedStructure: [],
};
export default DesktopNavigation;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/DesktopNavigation/index.jsx